import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-consume-record",
  "use": "icon-consume-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-consume-record\"><path d=\"M832 64a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H192a128 128 0 0 1-128-128V192a128 128 0 0 1 128-128h640z m0 64H192a64 64 0 0 0-63.552 56.512L128 192v640a64 64 0 0 0 56.512 63.552L192 896h640a64 64 0 0 0 63.552-56.512L896 832V192a64 64 0 0 0-56.512-63.552L832 128z\" p-id=\"10029\" /><path d=\"M352 480h320a32 32 0 0 1 0 64h-320a32 32 0 0 1 0-64z\" p-id=\"10030\" /><path d=\"M544 437.568V800a32 32 0 1 1-64 0V437.568a32 32 0 1 1 64 0z\" p-id=\"10031\" /><path d=\"M348.16 238.848l180.992 181.056a32 32 0 1 1-45.248 45.248L302.848 284.096a32 32 0 1 1 45.248-45.248z\" p-id=\"10032\" /><path d=\"M675.84 238.848L494.912 419.904a32 32 0 1 0 45.248 45.248l181.056-181.056a32 32 0 0 0-45.248-45.248zM352 608h320a32 32 0 0 1 0 64h-320a32 32 0 0 1 0-64z\" p-id=\"10033\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/consume-record.svg
// module id = 9Dzw
// module chunks = 36